import {get} from "lodash";

/**
 * Unique Redux store key associated with this reducer
 * IMPORTANT: All reducers must export this value!
 * @type {string}
 */
export const reducerStoreKey = 'asyncDownload';

// Define reducer types handled by this reducer
export const REDUCER_TYPES = {
	RESET: '@asyncDownload/reset',
	
	SET_ASYNC_DOWNLOAD_CHECK_LIST: '@asyncDownload/set_async_download_check_list',
};

// Define action creators for all reducer types
export const actionCreators = {
	reset: () => ({type: REDUCER_TYPES.RESET}),

	/**
	 * @param {AsyncDownloadCheckListItemDataObject[]|undefined} list
	 * @return {{type: string, list: AsyncDownloadCheckListItemDataObject[]|undefined}}
	 */
	setAsyncDownloadCheckList: list => ({type: REDUCER_TYPES.SET_ASYNC_DOWNLOAD_CHECK_LIST, list}),
};

/**
 * Initial reducer state
 * IMPORTANT: All reducers must export an initial state object!
 * @type {Object<string, any>}
 */
export const initialState = {
	/** @type {?AsyncDownloadCheckListItemDataObject[]|undefined} */
	checkList: null,
};

// Reducer function
const reducer = (state = {...initialState}, action) => {
	switch (action.type) {
		case REDUCER_TYPES.RESET: return { ...initialState };

		case REDUCER_TYPES.SET_ASYNC_DOWNLOAD_CHECK_LIST: return {...state, checkList: action.list};

		default: return state;
	}
};

// Selectors
export const selectors = {
	/** @returns {?AsyncDownloadCheckListItemDataObject[]|undefined} */
	getAsyncDownloadCheckList: state => get(state, [reducerStoreKey, 'checkList']),
};

export default reducer;